import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { getLoginRedirectPath } from '../utils/authUtils';

/**
 * Component that redirects authenticated users to the appropriate dashboard
 * based on their plan and role (team admin -> /team, others -> /dashboard)
 */
const RedirectAfterLogin = () => {
  const { authState } = useAuth();
  const [redirectPath, setRedirectPath] = useState('/dashboard');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const determineRedirect = async () => {
      if (authState?.user && authState?.token) {
        try {
          const path = await getLoginRedirectPath(authState.user, authState.token);
          setRedirectPath(path);
        } catch (error) {
          console.error('Error determining redirect path:', error);
          setRedirectPath('/dashboard');
        }
      }
      setIsLoading(false);
    };

    determineRedirect();
  }, [authState?.user, authState?.token]);

  if (isLoading) {
    return null; // Or a loading spinner
  }

  return <Navigate to={redirectPath} replace />;
};

export default RedirectAfterLogin;
